import { inject, Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SEOService {
  private meta = inject(Meta);

  /**
   * Updates all SEO related meta tags based on the environment. <br/>
   * In production, it does nothing yet.
   * In non-production environments, it adds a `noindex` meta tag to prevent search engines from indexing the site.
   */
  updateMetaTags() {
    const enableSearchIndexing = environment?.['enableSearchIndexing'] ?? false;
    if (!enableSearchIndexing) {
      this.meta.addTag({ name: 'robots', content: 'noindex' });
    }
  }
}
